import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
      margin:  ${theme.layout.spacing.decy} 0 0 0;
   `}
`;

export const ColumnNameCont = styled.div`
  height: 100%;
  display: flex;
  align-items: end;
`;

export const CategoriesResultsCont = styled.div`
  display: flex;
  flex: 1;
  margin: 0 0 0 auto;
  justify-content: space-evenly;
  position: relative;

  ${({ theme }: IThemeProvider) => `
    @media ${theme.layout.breakpoints.min.desktop} {
      max-width: 440px;
      min-width: 440px;
    }
    @media ${theme.layout.breakpoints.max.desktop} {
      max-width: 400px;
      min-width: 400px;
    }
  `}
`;
